import { useMemo } from "react";
import { useTournamentContext } from "../../../../hook/context";
import {
  EditTournamentParticipationContent,
  EditTournamentParticipationSettingBox,
  EditTournamentParticipationWrapper,
  EditTournamentParticipationInputWrapper,
  EditTournamentParticipationInputBox,
} from "./style";
import { EditTournamentCheckBox } from "../../style";

const EditTournamentParticipation = () => {
  const {
    buyIn,
    setBuyIn,
    buyInChip,
    setBuyInChip,
    reBuyIn,
    setReBuyIn,
    reBuyInChip,
    setReBuyInChip,
    addOn,
    setAddOn,
    adOnChip,
    setAdOnChip,
    isFreezeOut,
    setIsFreezeOut,
  } = useTournamentContext();

  const formatNumber = (value: string) => {
    return +value.replace(/[^0-9]/g, "");
  };

  const priceList = useMemo(() => {
    if (isFreezeOut) {
      return [
        {
          name: "바이인",
          price: buyIn,
          setPrice: setBuyIn,
          chip: buyInChip,
          setChip: setBuyInChip,
        },
      ];
    }

    return [
      {
        name: "바이인",
        price: buyIn,
        setPrice: setBuyIn,
        chip: buyInChip,
        setChip: setBuyInChip,
      },
      {
        name: "리바인",
        price: reBuyIn,
        setPrice: setReBuyIn,
        chip: reBuyInChip,
        setChip: setReBuyInChip,
      },
      {
        name: "애드온",
        price: addOn,
        setPrice: setAddOn,
        chip: adOnChip,
        setChip: setAdOnChip,
      },
    ];
  }, [adOnChip, addOn, buyIn, buyInChip, reBuyIn, reBuyInChip, isFreezeOut]);

  return (
    <EditTournamentParticipationWrapper>
      <div className="top">
        <div className="name">프리즈 아웃</div>
        <EditTournamentCheckBox>
          <input
            type="checkbox"
            checked={isFreezeOut}
            onChange={(e) => setIsFreezeOut(e.target.checked)}
          />
          {isFreezeOut && (
            <img src="/image-web/tournament/checked-icon.svg" alt="checked" />
          )}
        </EditTournamentCheckBox>
      </div>
      <EditTournamentParticipationContent>
        {priceList.map((p, i) => (
          <EditTournamentParticipationSettingBox key={i}>
            <div className="title">{p.name}</div>
            <EditTournamentParticipationInputWrapper>
              <EditTournamentParticipationInputBox>
                <div className="name">{p.name}</div>
                <input
                  value={p.price.toLocaleString()}
                  onChange={(e) => p.setPrice(formatNumber(e.target.value))}
                />
                <span>원</span>
              </EditTournamentParticipationInputBox>
              <EditTournamentParticipationInputBox>
                <div className="name">{p.name} 칩</div>
                <input
                  value={p.chip.toLocaleString()}
                  onChange={(e) => p.setChip(formatNumber(e.target.value))}
                />
                <span>칩</span>
              </EditTournamentParticipationInputBox>
            </EditTournamentParticipationInputWrapper>
          </EditTournamentParticipationSettingBox>
        ))}
      </EditTournamentParticipationContent>
    </EditTournamentParticipationWrapper>
  );
};

export default EditTournamentParticipation;
